import ko from "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("spaceIfEmpty", {
    init() {
        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor) {
        // This will be called once when the binding is first applied to an element,
        // and again whenever the associated observable changes value.
        // Update the DOM element based on the supplied values here.

        handleText(element, valueAccessor);
    }
});

function handleText(element: HTMLElement, valueAccessor: () => any) {
    // First get the latest data that we're bound to
    const value = valueAccessor();

    // Next, whether or not the supplied model property is observable, get its current value
    const valueUnwrapped = ko.unwrap(value);

    // Empty value or not?
    if (valueUnwrapped === undefined || valueUnwrapped === null || valueUnwrapped.trim() === "") {
        element.replaceChildren(document.createTextNode("\u00A0"));
    } else {
        ko.utils.setTextContent(element, valueUnwrapped);
    }
}
